export default () => ({
  managables: null,
  siteInfo: null,
  userInfo: null,
  workers: null,
});
